export default "__VITE_ASSET__DzTcyUOE__"